import App from '@/App';
import Loader from '@components/Loader';
import AuthLayoutBlock from '@layouts/Auth/AuthLayout';
import { persistor, store } from '@redux/index';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { rootElement } from '@utils/consts';
import 'regenerator-runtime/runtime';

function Index(): JSX.Element {
  localStorage.openpages = Date.now();
  window.addEventListener('storage', function (e) {
      if(e.key == "openpages") {
          localStorage.page_available = Date.now();
      }
      if(e.key == "page_available") {
          alert("Sahara is already open in one tab. Please use only one instance of this platform.");
          window.location.href = "https://sahara.network/";
      }
  }, true);
  return (
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={<Loader />} persistor={persistor}>
          <Router>
            <AuthLayoutBlock>
              <App />
            </AuthLayoutBlock>
          </Router>
        </PersistGate>
      </Provider>
    </React.StrictMode>
  );
}

ReactDOM.render(Index(), rootElement);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
